import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments';
import { AppEnv } from '../environments/app-env';
import { Toast } from 'primeng/toast';
import { ToastKeys } from 'app/core/constants';

const icons = ['send', 'chevron-left', 'delete-outline', 'discount', 'sorter'];

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, TranslateModule, Toast],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    private readonly _iconRegistry = inject(MatIconRegistry);
    private readonly _sanitizer = inject(DomSanitizer);
    private readonly _authService = inject(AuthService);

    protected readonly ToastKeys = ToastKeys;

    constructor(private _translateService: TranslateService) {
        this._translateService.setDefaultLang('en');
        this._translateService.use('en');
        this.registerIcons();

        if (environment.appEnv === AppEnv.dev) {
            (window as any)['logout'] = () => {
                this._authService.logout({
                    logoutParams: {
                        returnTo: window.location.origin,
                    },
                });
            };
            (window as any)['reloadToken'] = () => {
                return firstValueFrom(this._authService.getAccessTokenSilently({ cacheMode: 'off' }));
            };
        }
    }

    private registerIcons() {
        // `wl` is abbreviation of `white-label`
        icons.forEach(icon =>
            this._iconRegistry.addSvgIconInNamespace(
                'wl',
                icon,
                this._sanitizer.bypassSecurityTrustResourceUrl(`/assets/images/icons/${icon}.svg`)
            )
        );
    }
}
